import Controller, { OnAfterFetch, OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import { TabWithContentAPI, TextAPI, ModalService } from '@philips-internal/oswald-ui-components';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services/model-service';
import BaseController from '../BaseController';
import { LastUserAccess } from '../../interfaces/last-user-acccess';
import { cast } from '../../utils/cast-helpers';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import './index.css';

@Controller({ fragment: 'profile', component: 'layout-profile' })
export default class ProfileController extends BaseController {

  private lastUserAccess: LastUserAccess;

  @Inject('tab-with-content-1')
  tabContent: TabWithContentAPI;

  @Inject('text-last-login')
  lastloginText: TextAPI;

  @Inject('text-last-login-mobile')
  lastloginTextMobile: TextAPI;

  @OnClick({ target: 'link-show-privacy-and-terms-modal' })
  onClickTermsOfUse(): void {
    ModalService.openFullscreen({
      closeable: true,
      fragment: 'profile-privacy-and-terms',
      onClose: () => { return },
      title: 'result.terms.guidance.and.regulatory',
    });
  }

  @OnClick({ target: 'link-change-password' })
  onClickChangePassword(): void {
    this.historyService.push(APPLICATION_ROUTES.PROFILE_CHANGE_PASSWORD);
  }

  @OnAfterFetch({ target: 'fetch-last-acess-date' })
  onMountFetchLastAccessDate(fetchEvent: FetchEvent): void {
    this.lastUserAccess = cast(fetchEvent.data);
    this.lastloginText.setValue(`${MessageService.translate('results.profile.last.login')}:${ModelService.format('date', this.lastUserAccess.dtLastAcess, { type: 'timestamp' })}`);
  }

  @OnAfterFetch({ target: 'fetch-last-acess-date-mobile' })
  onMountFetchLastAccessDateMobile(fetchEvent: FetchEvent): void {
    this.lastUserAccess = cast(fetchEvent.data);
    this.lastloginTextMobile.setValue(`${MessageService.translate('results.profile.last.login')}:${ModelService.format('date', this.lastUserAccess.dtLastAcess, { type: 'timestamp' })}`);
  }

}
